export default __webpack_public_path__ + "static/media/Commanders_Comm.19fb7733.jpg";